import React from 'react';
import Icon from '../../../components/AppIcon';

const HeroSection = () => {
  return (
    <div className="text-center py-12 md:py-16 lg:py-20 px-4">
      
      <div className="inline-block bg-[#FF8C00]/10 text-[#FF8C00] text-sm font-semibold px-4 py-1.5 rounded-full mb-6 border border-[#FF8C00]/20">
        Voor freelancers in België en Nederland
      </div>

      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
        Freelance contract generator voor België en Nederland
      </h1>
      
      <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed mb-4">
        Maak professionele freelance contracten, NDA-overeenkomsten en algemene voorwaarden op maat voor freelancers en zelfstandigen in België en Nederland.
      </p>

      <p className="text-sm text-muted-foreground max-w-2xl mx-auto mb-6 italic">
        Ontworpen voor freelancers en zelfstandigen in België en Nederland — inclusief zzp'ers, zelfstandigen, consultants en ondernemers.
      </p>
      
      <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mt-6 md:mt-8 text-sm md:text-base text-muted-foreground">
        <div className="flex items-center gap-2">
          <Icon name="Shield" size={20} color="var(--color-success)" />
          <span>Juridisch correct</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Zap" size={20} color="#FF8C00" />
          <span>In 30 seconden klaar</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="MapPin" size={20} color="#2F4E6F" />
          <span>België &amp; Nederland</span>
        </div>
        <div className="flex items-center gap-2">
          <Icon name="Lock" size={20} color="#2F4E6F" />
          <span>Geen account nodig</span>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-center gap-3 mt-6 text-xs text-muted-foreground">
        <span className="bg-gray-100 px-3 py-1 rounded-full">freelancers België</span>
        <span className="bg-gray-100 px-3 py-1 rounded-full">freelancers Nederland</span>
        <span className="bg-gray-100 px-3 py-1 rounded-full">zelfstandigen</span>
        <span className="bg-gray-100 px-3 py-1 rounded-full">zzp'ers</span>
        <span className="bg-gray-100 px-3 py-1 rounded-full">contract generator</span>
      </div>
    </div>
  );
};

export default HeroSection;